module.exports = "/_next/static/images/7e72d3e34a37f76225d8f5fc1f2ad8ab-hero-belinda-desktop.jpg";